import './Groups.scss';
// Modals
import { CreateGroupModalController } from './modals/CreateGroupModalController';
import CreateGroupModalView from './modals/CreateGroupModalView.html';
import { DeleteGroupAlertController } from './modals/DeleteGroupAlertController';
import DeleteGroupAlertView from './modals/DeleteGroupAlertView.html';
import { GroupsConstants } from './GroupsConstants';
import { GroupsUtils } from './GroupsUtils';
import { GroupsActions } from './GroupsActions';
import { GroupStatusesEnum } from './models/GroupStatuses';
export class GroupsController {
    static $inject = ['LoadingService', 'UsersService', '$timeout', 'BlipToastService', '$translate', 'ModalService', 'GroupsService', '$state', 'GroupsSegmentService', 'application'];
    constructor(LoadingService, UsersService, $timeout, BlipToastService, $translate, ModalService, GroupsService, $state, GroupsSegmentService, application) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.UsersService = UsersService;
        this.$timeout = $timeout;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.GroupsService = GroupsService;
        this.$state = $state;
        this.GroupsSegmentService = GroupsSegmentService;
        this.application = application;
        this.pages = 1;
        this.currentPage = 1;
        this.maxPerPage = 10;
        this.startItem = 0;
        this.endItem = 0;
        this.totalItems = 0;
        this.loadMembersBatchSize = 10;
        this.groups = [];
        this.filteredGroups = [];
        this.slicedGroups = [];
        this.pendingCreationGroups = [];
        this.openCreateGroupModal = async () => {
            await this.ModalService.showModal({
                template: CreateGroupModalView,
                controller: CreateGroupModalController,
                controllerAs: '$ctrl',
                inputs: {
                    createGroup: this.createGroup.bind(this),
                },
            });
        };
        this.openDeleteGroupModal = async (groupIndex) => {
            const group = this.slicedGroups[groupIndex];
            await this.ModalService.showModal({
                template: DeleteGroupAlertView,
                controller: DeleteGroupAlertController,
                controllerAs: '$ctrl',
                inputs: {
                    deleteGroup: this.deleteGroup.bind(this),
                    groupId: group.identity,
                    groupName: group.name,
                    trackGiveUp: this.trackDeleteGroupGiveUp.bind(this),
                },
            });
        };
        this.handleFilterChange = (event) => {
            const searchTerm = event.target.value?.toLowerCase();
            const auxGroups = searchTerm
                ? this.groups
                    .filter((group) => group.name.toLowerCase().includes(searchTerm))
                : this.groups;
            this.$timeout(() => {
                this.filteredGroups = auxGroups;
            });
            this.GroupsSegmentService.trackGroupsSearchGroup(this.application, searchTerm);
            this.setPaginationAndSliceGroups(this.currentPage, auxGroups);
        };
        this.handlePageChange = (event) => {
            const page = event.detail;
            if (this.currentPage === page) {
                return;
            }
            this.$timeout(() => {
                this.currentPage = page;
            });
            this.setPaginationAndSliceGroups(page);
        };
        this.onGroupEditClick = (groupIndex) => {
            const group = this.slicedGroups[groupIndex];
            this.GroupsSegmentService.trackGroupsEditGroup(this.application, group);
            this.$state.go(GroupsConstants.GROUP_DETAILS_STATE, { id: GroupsUtils.filterGroupIdentitySuffix(group.identity) });
        };
        this.getGroupsStatuses = async () => {
            try {
                const actions = [GroupsActions.CREATE, GroupsActions.DELETE];
                const groupsStatuses = await this.GroupsService.getGroupsStatuses(actions);
                return groupsStatuses;
            }
            catch (_) {
                return undefined;
            }
        };
        this.canGroupBeDeleted = (group, deleteActions) => {
            if (!deleteActions) {
                return true;
            }
            const deleteAction = deleteActions.find(deleteAction => GroupsUtils.addGroupIdentitySuffix(deleteAction.GroupId) === group.identity);
            return deleteAction?.Status != GroupStatusesEnum.PENDING;
        };
        this.createGroup = async (groupName, groupDescription) => {
            const groupRequest = {
                name: groupName,
                description: groupDescription,
            };
            try {
                this.LoadingService.startLoading();
                this.GroupsSegmentService.trackGroupsCreateGroupRequest(this.application, groupRequest);
                const result = await this.GroupsService.createGroup(groupRequest);
                if (!result) {
                    this.BlipToastService.show('danger', {
                        msg: await this.$translate('groups.messages.errors.createGroup.default.msg'),
                    });
                    return;
                }
                this.BlipToastService.show('success', {
                    msg: await this.$translate('groups.messages.success.createGroup.default.msg'),
                });
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('groups.messages.errors.createGroup.default.msg'),
                });
            }
            finally {
                this.LoadingService.stopLoading();
            }
        };
        this.deleteGroup = async (groupIdentity) => {
            const groupId = GroupsUtils.filterGroupIdentitySuffix(groupIdentity);
            try {
                this.LoadingService.startLoading();
                this.GroupsSegmentService.trackGroupsDeleteGroupRequest(this.application, groupId);
                const result = await this.GroupsService.deleteGroup(groupId);
                if (!result) {
                    this.BlipToastService.show('danger', {
                        msg: await this.$translate('groups.messages.errors.deleteGroup.default.msg'),
                    });
                    return;
                }
                const group = this.groups.find((group) => group.identity === groupIdentity);
                this.$timeout(() => {
                    group.canDelete = false;
                });
                this.BlipToastService.show('success', {
                    msg: await this.$translate('groups.messages.success.deleteGroup.default.msg'),
                });
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('groups.messages.errors.deleteGroup.default.msg'),
                });
            }
            finally {
                this.LoadingService.stopLoading();
            }
        };
        this.trackDeleteGroupGiveUp = async (groupId) => {
            this.GroupsSegmentService.trackGroupDeletionGiveUp(this.application, GroupsUtils.filterGroupIdentitySuffix(groupId));
        };
    }
    async $onInit() {
        try {
            this.LoadingService.startLoading();
            const groupsResult = await this.getGroups();
            if (groupsResult && groupsResult.items) {
                const groupsStatuses = await this.getGroupsStatuses();
                this.groups = groupsResult.items
                    .map((group) => ({
                    ...group,
                    loadingMembers: true,
                    canDelete: this.canGroupBeDeleted(group, groupsStatuses?.Delete),
                }));
                this.filteredGroups = this.groups;
                this.setPaginationAndSliceGroups();
                this.LoadingService.stopLoading();
                this.setGroupsMembersAsync();
            }
        }
        catch (error) {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('groups.messages.errors.default.msg'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async setGroupsMembersAsync() {
        if (!this.groups || this.groups.length === 0) {
            return;
        }
        const groupsIndetities = this.groups.map((group) => group.identity);
        let position = 0;
        while (position < groupsIndetities.length) {
            const groupsBatch = groupsIndetities.slice(position, position + this.loadMembersBatchSize);
            const groupsMembersTasks = groupsBatch.map((identity) => {
                return this.GroupsService.getGroupMembers(GroupsUtils.filterGroupIdentitySuffix(identity));
            });
            const response = await Promise.all(groupsMembersTasks);
            for (let i = 0; i < response.length; i++) {
                const groupIndex = this.groups
                    .findIndex((group) => GroupsUtils.filterGroupIdentitySuffix(group.identity) === response[i].groupId);
                this.groups[groupIndex].members = response[i]?.members || [];
                this.groups[groupIndex].loadingMembers = false;
            }
            position += this.loadMembersBatchSize;
        }
    }
    async getGroups() {
        const query = "(source eq 'WhatsApp Group') and substringof('IsActiveGroup=True', extras)";
        const filter = `&$filter=${encodeURIComponent(query)}`;
        const groupsResult = await this.UsersService.getUsers(filter, 0, 1024);
        return groupsResult;
    }
    getPaginationIndexes(items, page) {
        const startIndex = items.length === 0 ? -1 : (page - 1) * this.maxPerPage;
        const auxEndIndex = startIndex + this.maxPerPage;
        const endIndex = auxEndIndex >= items.length ? items.length : auxEndIndex;
        return { startIndex, endIndex };
    }
    setPaginationValues(startIndex, endIndex, items) {
        this.$timeout(() => {
            this.startItem = startIndex + 1;
            this.endItem = endIndex;
            this.totalItems = items.length;
            this.pages = Math.ceil(this.totalItems / this.maxPerPage);
        });
    }
    setPaginationAndSliceGroups(page = this.currentPage, groups = this.filteredGroups) {
        const { startIndex, endIndex } = this.getPaginationIndexes(groups, page);
        this.setPaginationValues(startIndex, endIndex, groups);
        this.$timeout(() => {
            this.slicedGroups = groups.slice(startIndex, endIndex);
        });
    }
}
GroupsController.$inject = ['LoadingService', 'UsersService', '$timeout', 'BlipToastService', '$translate', 'ModalService', 'GroupsService', '$state', 'GroupsSegmentService', 'application'];
